/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



// ===================== ANIMATION : REWARD ONLY ===================== //
const aniRewardOnlyInitial = {
    // ~~~~~~~~~~~~~~~~~~~~~ INITIAL STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: '0',
        width: '100%',
        position: 'absolute',
        top: pxToEm(0),
        left: '0',
        zIndex: '2'
    },
    '& .progressbar.type-result': {
        display: 'none'
        // marginBottom: '0',
        // marginTop: pxToEm(12)
    },
    // remove progess bar and share icons immediately (so they can be animated later)
    '& .progressbar.type-result, .facebook, .twitter': {
        display: 'none'
        // transform: 'translateY(300%)',
        // opacity: '0'
    },
    '& .rewardsfeedback': {
        '& .icon, .text': { opacity: '0', transform: 'translateX(-300%)' }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thin]: {
        '& .resultelements': {
            fontSize: '85%',
            textAlign: 'center'
        }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniRewardOnlyInitial };